import ContentContainer from "components/ContentContainer";
import FullPageContainer from "components/FullPageContainer";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

interface StyledFullPageContainerProps {
  sensingVisible: boolean;
}

export const StyledFullPageContainer = styled(
  FullPageContainer
)<StyledFullPageContainerProps>`
  padding-bottom: ${({ sensingVisible }) => (sensingVisible ? 0 : 150)}px;
  transition: padding-bottom 0.5s;

  @media (max-width: ${breakpoints.lg}) {
    padding-bottom: ${({ sensingVisible }) => (sensingVisible ? 0 : 300)}px;
    min-height: unset;
  }
`;

export const StyledContentContainer = styled(ContentContainer)`
  padding: 70px 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${breakpoints.lg}) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const ModulesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5vw;

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
    gap: 100px;
  }
`;
